<template>
    <div class="wp">
        <el-aside ref="aside" width="200" class="wrapper" :class="isUnfold ? 'menu-isUnfold' : 'menu-collapsed'" @mouseenter.native="handleMouseEnter" @mouseleave.native="handleMouseLeave">
            <core-sidebar-menus :menus="searchMenus" :collapse="isUnfold ? false : isCollapsed" :showTestTip="showTestTip"></core-sidebar-menus>
            <div class="global-search" :class="isCollapsed ? '' : 'setBg'" v-if="showSearch">
                <el-input
                    ref="menuSerach"
                    :placeholder="$translate('component.E202007300009', { defaultText: '请输入内容' })"
                    v-model="searchMenuName"
                    @keyup.enter.native="handleEnter">
                    <i slot="prefix" style="margin-left: 9px;font-size: 16px;" class="el-input__icon el-icon-search"></i>
                </el-input>
            </div>
        </el-aside>
        <div class="fixed-point" v-if="!isCollapsed" @click="handleFixedChange">
            <i v-if="isUnfold" class="el-icon-lock"></i>
            <i v-else class="el-icon-unlock"></i>
        </div>
    </div>
</template>
<script>
import { CoreSidebarMenus } from '@/components/core/themes/default/';
import { mapGetters, mapMutations } from 'vuex';
import bigDataLog from '@/utils/bigDataLog';
import { I18nMixins } from '@/components/utils/i18n';
import utils from '../../utils';

const DELAY_TIME = 300;

// IE closest函数polyfill
if (!Element.prototype.matches) {
    Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
export default {
    mixins: [I18nMixins],
    data() {
        return {
            isCollapsed: true,
            Timeout: null,
            searchMenuName: '',
            originMenu: [],
            searchMenus: [],
            isMenuItem: false,
            isUnfold: false
        };
    },
    props: {
        showSearch: {
            type: Boolean,
            default: true
        },
        showTestTip: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        menus() {
            return this.authority.length ? this.authority.map(item => {
                item['fdFrontLink'] = item.frontUrl;
                item['path'] = item.frontUrl;
                item['name'] = item.resourceName;
                return item;
            }) : [];
        },
        ...mapGetters(['authority', 'user', 'appList', 'applicationCode'])
    },
    methods: {
        handleFixedChange() {
            if (window._paq) {
                if (this.isUnfold) {
                    window._paq.push(['trackEvent', 'Menu', 'Click', '取消固定菜单']);
                } else {
                    window._paq.push(['trackEvent', 'Menu', 'Click', '固定菜单']);
                }
            }
            this.isUnfold = !this.isUnfold;
            localStorage.setItem('menuLockStatus', this.isUnfold);
            this.handleMouseLeave();
        },
        getResourceIds(v) {
            const tempArr = [];
            getId(v);

            function getId(v) {
                v.forEach(item => {
                    if (item.resourceType && +item.resourceType === 1 && item.subResources) {
                        getId(item.subResources);
                    } else if (item.resourceType && +item.resourceType === 2) {
                        tempArr.push(item);
                    }
                });
            }
            return tempArr;
        },
        handleEnter() {
            if (this.searchMenuName) {
                let temp = this.getResourceIds(this.originMenu);
                temp = temp.filter(item => {
                    return item.resourceName.indexOf(this.searchMenuName) !== -1;
                });
                this.searchMenus = temp;
            } else {
                this.searchMenus = this.originMenu;
            }
            if (window._paq) {
                window._paq.push(['trackEvent', 'Menu', 'Enter', '菜单搜索']);
            }
        },
        handleMouseEnter() {
            clearTimeout(this.Timeout);
            this.Timeout = setTimeout(() => {
                this.isCollapsed = false;
            }, DELAY_TIME);
        },
        handleMouseLeave() {
            clearTimeout(this.Timeout);
            this.Timeout = setTimeout(() => {
                if (!this.isUnfold) {
                    this.isCollapsed = true;
                }
            }, DELAY_TIME * 5);
        },
        getCurrenMenuInfo(element) {
            const info = [];
            let frontUrl = ''; // 当前菜单实际的url
            let resourceCode = ''; // 当前菜单resourceCode
            let system = ''; // 系统标识
            let isFirstTime = true;
            const getNodeInfo = (el) => {
                let menuItem;
                if (isFirstTime) {
                    isFirstTime = false;
                    menuItem = el.closest('.el-menu-item');
                    if (menuItem) {
                        // 如果子菜单项，则向上查询, 有子菜单的主菜单项则不上报
                        getNodeInfo(menuItem);
                        frontUrl = menuItem.parentNode.attributes['href'] && menuItem.parentNode.attributes['href'].nodeValue;
                        resourceCode = menuItem.parentNode.attributes['resourceCode'] && menuItem.parentNode.attributes['resourceCode'].nodeValue;
                        system = menuItem.parentNode.attributes['system'] && menuItem.parentNode.attributes['system'].nodeValue;
                        info.push(menuItem.innerText);
                    }
                } else {
                    const parentMenu = el.parentNode.closest('.el-submenu');
                    if (parentMenu) {
                        menuItem = parentMenu.querySelector('.el-submenu__title');
                        getNodeInfo(parentMenu);
                        info.push(menuItem.innerText);
                    }
                }
            };
            getNodeInfo(element);
            if (!frontUrl.startsWith('http')) {
                const { origin, pathname } = window.location;
                frontUrl = origin + pathname + frontUrl;
            }
            return { info, frontUrl, resourceCode, system };
        },
        menuInfoToMap(menuInfo) {
            const infoMap = new Map();
            menuInfo.forEach((item, index) => {
                if (item) {
                    const mapIndex = index + 1;
                    infoMap.set('model_name' + mapIndex, item);
                }
            });
            return infoMap;
        },
        mapToMessageObj(map) {
            let obj = Object.create(null);
            for (let [key, value] of map) {
                obj[key] = value;
            }
            return obj;
        },
        sendBigDataLog(element) {
            const { info, frontUrl, resourceCode, system } = this.getCurrenMenuInfo(element);
            if (info && info.length) {
                utils.setLocalStorage(info, frontUrl, resourceCode);
                // const infoMap = this.menuInfoToMap(info);
                // const message = this.mapToMessageObj(infoMap);
                // bigDataLog.sendDetailMessage(message, system);
            }
        },
        ...mapMutations({
            updateAuthority: 'updateAuthority'
        })
    },
    components: {
        CoreSidebarMenus
    },
    watch: {
        authority: {
            handler(newValue) {
                this.originMenu = newValue ? JSON.parse(JSON.stringify(newValue)) : [];
                this.searchMenus = JSON.parse(JSON.stringify(this.originMenu));
            },
            immediate: true
        }
    },
    mounted() {
        // 添加菜单访问统计
        this.$nextTick(() => {
            const { aside } = this.$refs;
            aside.$el.addEventListener('click', (e) => {
                let element = e.target;
                this.sendBigDataLog(element);

                if (window._paq) {
                    if (element.classList.contains('menu-icon')) {
                        element = element.parentNode;
                    }
                    if (element.classList.contains('el-menu-item') || element.parentNode.classList.contains('el-menu-item')) {
                        window._paq.push(['trackEvent', 'Menu', 'Click', element.innerText]);
                    }
                }
            });
        });
        const menuLockStatus = localStorage.getItem('menuLockStatus');
        if (menuLockStatus === 'true') {
            this.isUnfold = true;
        }
    },
    created() {
        utils.sendMenuData();
    }
};
</script>
<style lang="less">
@delayTime: .3s;

.menu-isUnfold{
    width: 200px;
}

.menu-collapsed {
    width: 56px;
    transition: width 0.2s ease @delayTime * 5;
}

.menu-collapsed:hover {
    width: 200px;
    transition: width 0.2s ease @delayTime;

    .el-menu:not(.el-menu--collapse) {
        width: 200px;
    }
}

.wp{
    position: relative;

    .fixed-point{
        position: absolute;
        top: 50%;
        right: -24px;
        z-index: 999;
        width: 24px;
        height: 50px;
        text-align: center;
        color: #fff;
        background-color: #232F3D;
        box-shadow: 2px 2px 5px #888;
        transform: translateY(-25px);
        border-top-right-radius: 7px;
        border-bottom-right-radius: 7px;
        line-height: 50px;
        cursor: pointer;
    }
}

.wrapper{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    scrollbar-width: thin;
    scrollbar-color: #666 transparent;

    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #666;
    }

    .global-search{
        padding: 10px;
        margin-bottom: 11px;
        height: 30px;

        .el-input{
            margin-left: -3px;

            .el-input__inner{
                padding-left: 35px;
                color: #fff;
                background-color: rgba(255,255,255,0);
                border: none;
            }
        }
    }

    .setBg{
        .el-input{
            .el-input__inner{
                padding-left: 35px;
                background-color: rgba(255,255,255,0.1);
            }
        }
    }
}
</style>
